import { getLinkType } from '@/datalayer/App.datalayer.utils';
import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  // Target
  CTA = 'a',
  // Content
  CTAheadline = '.gtm-tab[aria-selected="true"] .gtm-headline',
  Tab = '.gtm-tab',
  Tabtitle = '.gtm-headline',
}

export const mapTarget = mapTargetBySelectors([Selectors.CTA]);

export const onDatalayerScroll = ({ target }: OnDatalayerProps) => {
  const { tabTitle, variantName = '' } = target;

  if (!target) {
    return undefined;
  }

  return {
    event: 'scrollCarousel',
    eventCategory: 'Complex Tab',
    ...(!!tabTitle && { tabTitle }),
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;
  const documentHeadline =
    componentRef?.current?.querySelector(Selectors.CTAheadline)?.textContent || '';

  return {
    event: 'clickCTA',
    eventCategory: 'Complex Tab',
    ...(!!documentHeadline && { documentHeadline }),
    ...(variantName && { variant_name: variantName }),
  };
};

export const SCROLL_CARD_CAROUSEL_EVENTS = {
  linkClick: 'trackEvent-scrollCarouselLinkClick',
  ctaClick: 'trackEvent-scrollCarouselCtaClick',
};
export const SCROLL_CAROUSEL_EVENTS_NAMES = {
  linkClick: 'scroll_carousel_link_click',
  ctaClick: 'scroll_carousel_cta_click',
};

export const onDataLayerScrollCarouselTab =
  ({
    event = SCROLL_CARD_CAROUSEL_EVENTS.linkClick,
    eventName = SCROLL_CAROUSEL_EVENTS_NAMES.linkClick,
  }) =>
  ({ target }: OnDatalayerProps) => {
    if (!target) return undefined;

    const title = (target?.closest('[data-datalayer-scrollcarousel-title]') as HTMLDivElement)
      ?.dataset?.datalayerScrollcarouselTitle;
    const index = (target?.closest('[data-datalayer-scrollcarousel-index]') as HTMLDivElement)
      ?.dataset?.datalayerScrollcarouselIndex;
    const href = target?.href || '';
    const type = getLinkType(target);
    const linkText = target?.textContent?.trim();

    return {
      event,
      event_name: eventName,
      ...(!!href && { variant_name: href }),
      ...(!!linkText && { link_text: linkText }),
      ...(!!type && { type }),
      ...(!!title && { title }),
      ...(!!index && { index_num: String(index) }),
    };
  };
